/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Mock_ApproveInputs */

const en_cp_mock_approve = /** @type {(inputs: Cp_Mock_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve phase`)
};

const id_cp_mock_approve = /** @type {(inputs: Cp_Mock_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setujui fase`)
};

/**
* | output |
* | --- |
* | "Approve phase" |
*
* @param {Cp_Mock_ApproveInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_mock_approve = /** @type {((inputs?: Cp_Mock_ApproveInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Mock_ApproveInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_mock_approve(inputs)
	return en_cp_mock_approve(inputs)
});